import { useState } from "react";
import { toast } from "sonner";
import { KeyRound, UserCircle } from "lucide-react";
import { Layout } from "../components/layout/Layout";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Field, Panel } from "../components/common";
import { api, formatApiError } from "../lib/api";
import { useAuth, isEleve } from "../context/AuthContext";
import { fmtDate } from "../lib/format";

export default function ProfilPage() {
  const { user } = useAuth();
  const [cur, setCur] = useState("");
  const [nouveau, setNouveau] = useState("");
  const [confirm, setConfirm] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    if (nouveau !== confirm) return toast.error("Les deux nouveaux codes ne correspondent pas");
    try {
      await api.post("/auth/change-pin", { current_pin: cur, new_pin: nouveau });
      toast.success("Code PIN modifié");
      setCur(""); setNouveau(""); setConfirm("");
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };
  return (
    <Layout title="Mon profil">
      <div className="grid gap-5 lg:grid-cols-2 max-w-4xl">
        <Panel title="Mes informations" icon={UserCircle}>
          <dl className="grid grid-cols-[140px_1fr] gap-y-2 text-sm">
            <dt className="text-muted-foreground">Nom</dt><dd className="font-medium">{user.prenom} {user.nom}</dd>
            <dt className="text-muted-foreground">Matricule</dt><dd><code>{user.matricule}</code></dd>
            <dt className="text-muted-foreground">Type d'accès</dt><dd>{user.is_admin ? "Administrateur" : isEleve(user) ? "Élève (temporaire)" : "Formateur (permanent)"}</dd>
            {isEleve(user) && <><dt className="text-muted-foreground">Période</dt><dd>du {fmtDate(user.access_start)} au {fmtDate(user.access_end)}</dd></>}
            <dt className="text-muted-foreground">E-mail</dt><dd>{user.email || "—"}</dd>
          </dl>
        </Panel>
        <Panel title="Changer mon code PIN" icon={KeyRound}>
          <form onSubmit={submit} className="space-y-3">
            <Field label="Code PIN actuel"><Input type="password" inputMode="numeric" maxLength={8} value={cur} onChange={(e) => setCur(e.target.value)} required /></Field>
            <Field label="Nouveau code PIN (8 chiffres)"><Input type="password" inputMode="numeric" pattern="[0-9]{8}" maxLength={8} value={nouveau} onChange={(e) => setNouveau(e.target.value)} required /></Field>
            <Field label="Confirmer le nouveau code"><Input type="password" inputMode="numeric" pattern="[0-9]{8}" maxLength={8} value={confirm} onChange={(e) => setConfirm(e.target.value)} required /></Field>
            <Button type="submit">Modifier</Button>
          </form>
        </Panel>
      </div>
    </Layout>
  );
}
